import {
  PRESENTATION_COMPLETE,
  PRESENTATION_FIELD_UPDATE,
  PRESENTATION_SELECT_STEP
} from '../../actions/early/presentation'
import * as earlyListingActions from '../../actions/early/earlyListing'
import * as h2Api from '../../h2Api'

const initialState = {
  step: 0,
  summaryExplanation: '',
  pathwaysExplanation: '',
  occupationsExplanation: '',
  budgetExplanation: '',
  conclusionExplanation: '',
  clustersExplanation: '',
  completedAt: null
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case earlyListingActions.LOAD_GAME:
      console.log(action.restCall.result)

      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          ...action.restCall.result.presentation
        }
      }

      return state
    case PRESENTATION_SELECT_STEP:
      return {
        ...state,
        step: action.step
      }
    case PRESENTATION_FIELD_UPDATE:
      return {
        ...state,
        [action.fieldName]: action.value
      }
    case PRESENTATION_COMPLETE:
      return {
        ...state,
        completedAt: new Date()
      }
    default:
      return state
  }
}

export default reducers
